

        <div class="dropdown" *ngIf="gatePass.is_logged_in">
        <a  class="nav-link dropdown-toggle"  href="#" role="button"  data-bs-toggle="dropdown" aria-expanded="false" id="dropdownMenuUser">
          <div class="d-none d-md-block"> <i class='fa fa-user'></i></div>
          <i class='fa fa-user d-md-none'></i> {{gatePass.username}}<span class="caret"></span>
        </a>



        <ul class="dropdown-menu" role="menu"  aria-labelledby="dropdownMenuUser">
          <li>
            <a *ngIf="(gatePass.is_role_admin||gatePass.is_role_guardian)" [routerLink]="['/user/edit',user_id]" action="edit" class="nav-link dropdown-item">
              <i class="fa fa-user"> </i> Account</a>
            </li>
            <li>
            <a  href="#" class="nav-link dropdown-item" (click)="logout()"> <i class="fa fa-sign-out"> </i> Logout</a>
            </li>
        </ul>
      </div>
